export type SignInErrorCause =
  | "cancelled"
  | "network_fail"
  | "timeout"
  | "unknown";

export class SignInError extends Error {
  public cause: SignInErrorCause;

  constructor(message: string, cause: SignInErrorCause) {
    super(message);
    this.name = "SignInError";
    this.cause = cause;
  }
}
